import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/outline";

const SuccessModal = ({ show, message = "Success!", onClose }) => {
  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl px-8 py-6 flex flex-col items-center text-center animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <CheckCircleIcon className="h-16 w-16 text-green-500 mb-3 animate-bounce" />
        <p className="text-lg font-semibold text-gray-800">{message}</p>
      </div>
    </div>
  );
};

export default SuccessModal;
